interface IDocumentoIconProps {
  color: string;
}

export const DocumentoIcon: React.FC<IDocumentoIconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2291_6176)">
        <path
          d="M16 20.5V4.5H4V19.5C4 19.7652 4.10536 20.0196 4.29289 20.2071C4.48043 20.3946 4.73478 20.5 5 20.5H16ZM19 22.5H5C4.20435 22.5 3.44129 22.1839 2.87868 21.6213C2.31607 21.0587 2 20.2956 2 19.5V3.5C2 3.23478 2.10536 2.98043 2.29289 2.79289C2.48043 2.60536 2.73478 2.5 3 2.5H17C17.2652 2.5 17.5196 2.60536 17.7071 2.79289C17.8946 2.98043 18 3.23478 18 3.5V10.5H22V19.5C22 20.2956 21.6839 21.0587 21.1213 21.6213C20.5587 22.1839 19.7956 22.5 19 22.5ZM18 12.5V19.5C18 19.7652 18.1054 20.0196 18.2929 20.2071C18.4804 20.3946 18.7348 20.5 19 20.5C19.2652 20.5 19.5196 20.3946 19.7071 20.2071C19.8946 20.0196 20 19.7652 20 19.5V12.5H18ZM6 6.5H12V12.5H6V6.5ZM8 8.5V10.5H10V8.5H8ZM6 13.5H14V15.5H6V13.5ZM6 16.5H14V18.5H6V16.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2291_6176">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
